import React, { createContext } from "react";

import { merge } from 'lodash';

export const AppContext = createContext();

const verticalScrollOptions = {
  threshold: 0.75
};

export class AppContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.verticalScrollObserver = new IntersectionObserver(function(
      entries,
      verticalScrollObserver
    ) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.children.length > 0) {
            entry.target.classList.add("appear");
          }
        }
      });
    },
    verticalScrollOptions);
  }

  verticalScrollObserve = target => {
    this.verticalScrollObserver.observe(target);
  };

  updateState = (update) => {
    const newState = merge({}, this.state, update);
    
    this.setState(newState);
  }

  render() {
    return (
      <AppContext.Provider
        value={{
          ...this.state,
          updateState: this.updateState,
          verticalScrollObserve: this.verticalScrollObserve
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
